export const MESSAGE_EVENTS = {
  AuthDone: 'rw_done',
  RedirectMailSent: 'rw_redir_mail_sent',
  RedirectTXStatus: 'rw_tx_status_page',
};
